module.exports = __webpack_public_path__ + "static/media/09.cfa400c6.mp3";